import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'

const { LOGOS, USA } = DEFAULT
const { CONTENT_V2: content } = USA

const partnerName = 'Fidelis Care of New York'

const fidelisCareNewYork: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...USA.CONFIG_V2,
    name: partnerName,
    id: 'fidelis-care',
    productConfigAppName: 'fidelis-care',
    codes: {
      membership: 'Fidelis',
    },
    partnerUrlSlug: 'fidelis',
  },
  content,
}

const fidelisCareNewYorkWithDnaV2Design: PartnerConfig = {
  ...fidelisCareNewYork,
  branding: {
    logo: [
      LOGOS.BABYLON,
      {
        src: '/images/USA/Fidelis/new-york.png',
        alt: `${partnerName} logo`,
      },
    ],
  },
  config: {
    ...fidelisCareNewYork.config,
    useDnaV2Design: true,
  },
}

export default [fidelisCareNewYork, fidelisCareNewYorkWithDnaV2Design]
